import { FC, PropsWithChildren } from 'react';
import { triggerTracking } from '@zoopla/tracking';
import { styledJumpLinkStyle, textStyle } from './JumpLink.styles.css';
import { GA_CUSTOM_EVENT, GA_CUSTOM_CATEGORY } from '../../constants';
import { fontGroups } from '@zoopla-eng/zds-components/themes/font-groups';

type ElementProps = {
    id: string;
    type: string;
};

function Element({ id, type, children }: PropsWithChildren<ElementProps>) {
    if (type === 'heading-2') {
        return (
            <h2 id={id} className={fontGroups.plate}>
                {children}
            </h2>
        );
    } else if (type === 'heading-3') {
        return (
            <h3 id={id} className={fontGroups.mug}>
                {children}
            </h3>
        );
    }

    return (
        <p className={`${textStyle} ${fontGroups.ladle}`} id={id}>
            {children}
        </p>
    );
}

type JumplinkProps = {
    type: string;
    text: string;
};

const JumpLink: FC<PropsWithChildren<JumplinkProps>> = ({
    type,
    text,
    children
}) => {
    // Remove special characters from the URI slug, lower cases it all and trims any trailing hyphen
    const processedLink = text
        .replace(/[^A-Za-z0-9]/g, '-')
        .toLowerCase()
        .replace(/-*$/g, '');

    return (
        <a
            className={styledJumpLinkStyle}
            href={`#${processedLink}`}
            onClick={function () {
                triggerTracking({
                    event: GA_CUSTOM_EVENT,
                    eventCategory: GA_CUSTOM_CATEGORY,
                    eventAction: 'clickthrough',
                    eventLabel: `jump link,#${processedLink}`
                });
            }}
        >
            <Element id={processedLink} type={type}>
                {children}
            </Element>
        </a>
    );
};

export default JumpLink;
